// tenant-settings.ts — Endpoints des paramètres du tenant (table singleton).
import { req } from './_internals.js';

export const tenantSettingsApi = {
  getTenantSettings: () => req('GET', '/tenant-settings'),
  updateTenantSettings: (d: unknown) => req('PUT', '/tenant-settings', d),
};
